import React from "react";

import { TextButton } from "@nykaa/payment-ui/src/Button";
import { Image } from "@nykaa/payment-ui/src/Image";
import { Title } from "@nykaa/payment-ui/src/Title";
import { Timer } from "@nykaa/payment-sdk/src/UpiTimerScreen/components/Timer";

import { Icon, TitleWrapper, UpiTimerScreenWrapper } from "../assets/style";

export const AddressUpiTimerScreen = ({ upiTimerConfig, theme }: any) => {
  return (
    <UpiTimerScreenWrapper>
      <Title
        text={upiTimerConfig.headerText}
        font={theme.typography.titleXLarge}
        color={theme.colors.textPrimary}
      />
      <Title
        text={upiTimerConfig.topSubtitleMessage}
        font={theme.typography.subTitleMedium}
        color={theme.colors.textSecondary}
      />

      <Timer
        text={upiTimerConfig.timerText}
        timeLeft={upiTimerConfig.timeLeft}
        totalTime={upiTimerConfig.totalTime}
        theme={theme}
        isBeautyPlatform={upiTimerConfig.isBeautyPlatform}
      />

      <Title
        text={upiTimerConfig.paymentStepTitleText}
        font={theme.typography.subTitleLarge}
        color={theme.colors.textPrimary}
      />

      {upiTimerConfig?.paymentSteps?.length &&
        upiTimerConfig?.paymentSteps?.map((step: any) => {
          return (
            <TitleWrapper>
              <Icon>
                <Image url={step.icon} alt={"icon"} theme={theme} />
              </Icon>
              <Title
                text={step.text}
                font={theme.typography.bodySmall}
                color={theme.colors.textPrimary}
              />
            </TitleWrapper>
          );
        })}
      <TextButton
        text={"Cancel"}
        onClick={upiTimerConfig.bottomSheetSuccessAction}
        theme={theme}
        dataTestId="cancel-btn"
      />
    </UpiTimerScreenWrapper>
  );
};
